export default __webpack_public_path__ + "static/media/TeaIcon.02743bc8.png";